var map = {
	"./azxy10_icon.png": "f96a",
	"./azxy20_icon.png": "bd5d",
	"./azxy5_icon.png": "492c",
	"./azxy8_icon.png": "6011",
	"./cannon20_icon.png": "c30b",
	"./cannon20ex_icon.png": "96ed",
	"./gamma3_icon.png": "b204",
	"./gamma3ex_icon.png": "e768",
	"./infinity8_icon.png": "98c5",
	"./infinity8ex_icon.png": "75b9",
	"./jisukuai3_icon.png": "81eb",
	"./jisukuaile_icon.png": "a6f6",
	"./jisusaiche_icon.png": "7924",
	"./jisushishi_icon.png": "2fa9",
	"./kl8lhc_icon.png": "ebcb",
	"./lucky5_icon.png": "05cc",
	"./lucky5ex_icon.png": "1bab",
	"./lucky7daily_icon.png": "3108",
	"./megamillions_icon.png": "c33c",
	"./penta5_icon.png": "4c95",
	"./penta5classic_icon.png": "4fba",
	"./penta5ex_icon.png": "b6d7",
	"./penta_icon.png": "5892",
	"./pl3_icon.png": "2a07",
	"./pl5_icon.png": "f8f7",
	"./pl5daily_icon.png": "3d97",
	"./powerball_icon.png": "95e2",
	"./qxc_icon.png": "b443",
	"./rolling10_icon.png": "5cca",
	"./rolling10ex_icon.png": "81c0",
	"./sgplhc_icon.png": "2ac3",
	"./surfing10classic_icon.png": "d20c",
	"./twbg_icon.png": "387d",
	"./twbglhc_icon.png": "6c5d",
	"./twbgsch_icon.png": "4e46",
	"./twbgscq_icon.png": "205b",
	"./xglhc_icon.png": "0dd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1a8";